import React from 'react';
import type { IconComponentProps } from '@/types/components';

export const JpgIcon: React.FC<IconComponentProps> = ({ className }) => (
  <svg
    className={className}
    width="77"
    height="76"
    viewBox="0 0 77 76"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="jpg-icon-mask"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="77"
      height="76"
    >
      <rect width="77" height="76" rx="4" fill="#D9D9D9" />
    </mask>
    <g mask="url(#jpg-icon-mask)">
      <rect
        x="-10"
        y="-6"
        width="97"
        height="87"
        className="fill-[#E2E8FB] dark:fill-[#232A44]"
      />
      <path
        d="M42.2532 18H27.2269C25.7801 18 24.6006 19.1795 24.6006 20.6341V55.6328C24.6006 57.0874 25.78 58.259 27.2347 58.2669H53.6154C55.0701 58.2669 56.2417 57.0874 56.2495 55.6328L56.1709 29.6374L42.2532 18Z"
        fill="#77A4E5"
      />
      <path
        d="M42.2546 18L42.2153 29.3622C42.2153 29.3622 42.2546 29.6374 42.4905 29.6374H56.1723L42.2546 18Z"
        fill="#4B7AE2"
      />
      <path
        d="M22.0694 37.3982H48.6152C49.2049 37.3982 49.6846 37.8778 49.6846 38.4676V50.3251C49.6846 50.9149 49.2049 51.3945 48.6152 51.3945H22.0694C21.4796 51.3945 21 50.9149 21 50.3251V38.4676C21 37.8778 21.4796 37.3982 22.0694 37.3982Z"
        fill="#4B7AE2"
      />
      <g className="fill-white dark:fill-[#292C4B]">
        <path d="M29.3077 46.1784V41.1066H31.0805V46.1784C31.0805 46.6725 30.9674 47.1006 30.7411 47.4628C30.5183 47.8249 30.2143 48.1059 29.8294 48.3055C29.4478 48.5018 29.0189 48.6 28.5428 48.6C28.0498 48.6 27.6108 48.5171 27.2258 48.3512C26.8442 48.1854 26.5437 47.9299 26.3242 47.5846C26.1081 47.2394 26 46.7994 26 46.2647H27.783C27.783 46.5151 27.8117 46.7114 27.8691 46.8536C27.9265 46.9923 28.0109 47.0905 28.1224 47.148C28.2372 47.2022 28.3773 47.2293 28.5428 47.2293C28.7049 47.2293 28.8416 47.1886 28.9531 47.1074C29.0679 47.0228 29.1557 46.9026 29.2165 46.747C29.2773 46.5879 29.3077 46.3984 29.3077 46.1784Z" />
        <path d="M35.153 45.9905H33.3194V44.6147H35.153C35.4029 44.6147 35.6055 44.5724 35.7609 44.4878C35.9162 44.4032 36.0293 44.2864 36.1002 44.1375C36.1745 43.9852 36.2117 43.8143 36.2117 43.6247C36.2117 43.4216 36.1745 43.2338 36.1002 43.0612C36.0293 42.8886 35.9162 42.7498 35.7609 42.6449C35.6055 42.5366 35.4029 42.4824 35.153 42.4824H33.988V48.4985H32.2101V41.1066H35.153C35.744 41.1066 36.2522 41.2149 36.6777 41.4315C37.1065 41.6481 37.4358 41.946 37.6654 42.3251C37.8951 42.7007 38.0099 43.1306 38.0099 43.6146C38.0099 44.0918 37.8951 44.5081 37.6654 44.8635C37.4358 45.2188 37.1065 45.4964 36.6777 45.6961C36.2522 45.8924 35.744 45.9905 35.153 45.9905Z" />
        <path d="M45 44.5487V47.5846C44.8751 47.7234 44.6826 47.8723 44.4226 48.0314C44.1659 48.1871 43.8417 48.3208 43.45 48.4325C43.0583 48.5442 42.5974 48.6 42.0672 48.6C41.5775 48.6 41.1335 48.5222 40.735 48.3665C40.3365 48.2074 39.9938 47.9756 39.7067 47.6709C39.4231 47.3629 39.2036 46.9873 39.0483 46.5439C38.8963 46.0971 38.8203 45.5861 38.8203 45.0107V44.5995C38.8203 44.0241 38.898 43.513 39.0533 43.0663C39.2087 42.6195 39.4265 42.2438 39.7067 41.9392C39.9904 41.6312 40.323 41.3977 40.7046 41.2386C41.0896 41.0795 41.5117 41 41.9709 41C42.6497 41 43.2018 41.1083 43.6273 41.3249C44.0528 41.5381 44.3753 41.8343 44.5948 42.2134C44.8143 42.589 44.9477 43.024 44.9949 43.5181H43.2879C43.2542 43.2744 43.19 43.068 43.0954 42.8987C43.0043 42.7261 42.8726 42.5958 42.7003 42.5078C42.5281 42.4164 42.3053 42.3707 42.0317 42.3707C41.819 42.3707 41.6248 42.4164 41.4492 42.5078C41.277 42.5992 41.1301 42.738 41.0085 42.9241C40.887 43.1069 40.7924 43.337 40.7249 43.6146C40.6607 43.8921 40.6286 44.217 40.6286 44.5893V45.0107C40.6286 45.3796 40.659 45.7028 40.7198 45.9804C40.784 46.2579 40.8785 46.4897 41.0035 46.6759C41.1318 46.8587 41.2939 46.9974 41.4897 47.0922C41.689 47.1836 41.9237 47.2293 42.1938 47.2293C42.3829 47.2293 42.545 47.214 42.6801 47.1836C42.8152 47.1497 42.9266 47.1091 43.0144 47.0617C43.1056 47.011 43.1748 46.9636 43.2221 46.9196V45.7722H41.9861V44.5487H45Z" />
      </g>
    </g>
  </svg>
);
